import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import Logo from '@comp/Logo/Logo';
import { breakpoints, Spacings } from '@styles/index';
import HeaderTop from '../Components/HeaderContainer';
import HeaderContent from '../Components/HeaderParent';

const HeaderContainer = styled(HeaderTop)`
  background: var(--color-base-1);
  position: static;
  @media only screen and (max-width: 768px) {
    height: 72px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    box-shadow: inset 0px -1px 0px var(--color-shadow);
    display: block;
    width: 100%;
    height: 48px;
    background: var(--color-base-1);
  }
`;

const HeaderParent = styled(HeaderContent)`
  @media only screen and (max-width: 768px) {
    width: 100%;
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
  }
  @media only screen and (max-width: 540px) {
    display: flex;
    width: 100%;
    padding: ${Spacings.SPACING_4B};
    justify-content: space-between;
  }
`;

const Header = () => {
  const router = useRouter();
  const { route } = router;
  return (
    <HeaderContainer>
      <HeaderParent>
        <Logo isClassroom={route.includes('classroom')} />
      </HeaderParent>
    </HeaderContainer>
  );
};

export default Header;
